import { animate, style, transition, trigger } from '@angular/animations';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  Output,
} from '@angular/core';
import { ModalWindowWrapper } from '../../models';
import { IS_MOBILE_TOKEN } from '@anecdotes/design-system/injection-tokens';

@Component({
  selector: 'app-side-panel-modal',
  templateUrl: './side-panel-modal.component.html',
  styleUrls: ['./side-panel-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('rightPanelInOut', [
      transition(':enter', [
        style({ transform: 'translate(100%, 0)' }),
        animate('150ms', style({ transform: 'none' })),
      ]),
      transition('open => close', [animate('150ms', style({ transform: 'translate(100%, 0)' }))]),
    ]),
  ],
})
export class SidePanelModalComponent {
  @HostBinding('class')
  private readonly classes = 'block w-screen h-screen relative pointer-events-none';

  @Input()
  modalWindowWrapper: ModalWindowWrapper;

  @Output()
  closeModal = new EventEmitter<void>();

  protected displayModal = true;

  protected get animationState(): 'open' | 'close' {
    return this.displayModal ? 'open' : 'close';
  }

  protected get isCloseBtnDisplayed(): boolean {
    // undefined is not equal to false, so undefined for options object fields means that user didn't provide this option and undefined used as default value.
    return this.modalWindowWrapper.modalWindow.options?.closeBtnDisplay !== false;
  }

  get sidePanelWidth(): string {
    if (!this.modalWindowWrapper?.type) {
      return '';
    }

    switch (this.modalWindowWrapper?.type) {
      case 'right-1/4':
        return 'w-1/4';
      case 'right-3/4':
        return 'w-3/4';
      case 'right-1/2':
        return 'w-1/2';
      default:
        return this.modalWindowWrapper.type;
    }
  }

  constructor(
    private readonly cd: ChangeDetectorRef,
    @Inject(IS_MOBILE_TOKEN) readonly isMobile: boolean,
  ) {}

  protected animationDone(event): void {
    if (event.toState === 'close') {
      this.closeModal.emit();
    }
  }

  protected handleClose(): void {
    this.displayModal = false;
    this.cd.detectChanges();
  }
}
